__turbopack_context__.v({
  "ctaCard": "hw6Tyq_ctaCard",
  "ctaCardImage": "hw6Tyq_ctaCardImage",
  "ctaCardPrice": "hw6Tyq_ctaCardPrice",
  "ctaCardTitle": "hw6Tyq_ctaCardTitle",
  "ctaInner": "hw6Tyq_ctaInner",
  "ctaSection": "hw6Tyq_ctaSection",
  "ctaUnavailable": "hw6Tyq_ctaUnavailable",
  "heroSection": "hw6Tyq_heroSection",
  "heroSubtitle": "hw6Tyq_heroSubtitle",
  "heroTitle": "hw6Tyq_heroTitle",
});
